import { ResultState } from "../actions/types";

const INITAL_STATE: ResultState = [];

export default (state = INITAL_STATE, action: { type: string, payload: ResultState }) => {
  switch (action.type) {
    case "PERFORM_SEARCH":
      return action.payload;
    default:
      return state;
  }
}
